import { stateStatusType, VideoEpisodeProps,  } from './actionType';

// FetchVideoEpisodeState
export interface FetchVideoEpisodesState {
    isLoading: boolean;
    error: string | null;
    video_episode: VideoEpisodeProps[];
    status: stateStatusType | null;
}
export interface GenericVideoEpisodeState {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
}

export const initialVideoEpisodeState: FetchVideoEpisodesState = {
    isLoading: false,
    error: null,
    video_episode: [],
    status: null
};

export const initialGenericVideoEpisodeState: GenericVideoEpisodeState = {
    isLoading: false,
    error: null,
    status: null
};

export interface VideoEpisodeState {
    videoEpisodeState: FetchVideoEpisodesState;
    genericVideoEpisodeState: GenericVideoEpisodeState;
}

export const initialState: VideoEpisodeState = {
    videoEpisodeState: initialVideoEpisodeState,
    genericVideoEpisodeState: initialGenericVideoEpisodeState,
};


